import React from 'react';
import { _ } from '../../../functions/translator';

class ZoneInfo extends React.Component{

    render(){

        let zoneValue = this.props.cardsGroup.attributes.zone ? this.props.cardsGroup.attributes.zone : _('Ninguna')

        let zone = _("Zona")

        if (this.props.customcard) {
            if (!this.props.customcard.attributes.zone) return <div></div>
            zone = this.props.customcard.attributes.zone
        }

        return (
            <div className='info-container'>
                <p className='card-text'>{ zone }</p>
                <span className='text card-description'>{ zoneValue }</span>
            </div>
        );
    }
}

export default ZoneInfo;